import { createMuiTheme } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    mobile: true;
    tablet: true;
    tabletEx: true;
    laptop: true;
  }
}

interface ThemeColor {
  main: string;
  gradationBegin: string;
  gradationEnd: string;
}
declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    themeColor: ThemeColor;
  }
  interface PaletteOptions {
    themeColor: ThemeColor;
  }
}

const tabletWidth = 768;

const defaultTheme = createMuiTheme();
export const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      mobile: 375,
      tablet: tabletWidth,
      tabletEx: 1024,
      laptop: 1366,
    },
  },
  palette: {
    themeColor: {
      main: '#4E7FF2',
      gradationBegin: '#6A8AFF',
      gradationEnd: '#6AA4FF',
    },
  },
  typography: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'ヒラギノ角ゴシック', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ Pro W3', Roboto, 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif",
    h1: {
      color: '#333333',
      fontSize: '28px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
      [defaultTheme.breakpoints.up(tabletWidth)]: {
        fontSize: '32px',
      },
    },
    h2: {
      color: '#333333',
      fontSize: '24px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
      [defaultTheme.breakpoints.up(tabletWidth)]: {
        fontSize: '28px',
      },
    },
    h3: {
      color: '#333333',
      fontSize: '20px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
      [defaultTheme.breakpoints.up(tabletWidth)]: {
        fontSize: '24px',
      },
    },
    h4: {
      color: '#333333',
      fontSize: '20px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
    },
    h5: {
      color: '#333333',
      fontSize: '17px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
    },
    h6: {
      color: '#333333',
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
    },
    subtitle1: {
      color: '#333333',
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 'normal',
      letterSpacing: 0,
    },
    subtitle2: {
      color: '#333333',
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 'normal',
      letterSpacing: 0,
    },
    body1: {
      color: '#333333',
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 'normal',
      letterSpacing: 0,
    },
    body2: {
      color: '#333333',
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 'normal',
      letterSpacing: 0,
    },
    button: {
      color: '#333333',
      fontSize: '16px',
      lineHeight: '1.5',
      fontWeight: 'bold',
      letterSpacing: 0,
    },
    caption: {
      color: '#333333',
      letterSpacing: 0,
    },
    overline: {
      color: '#333333',
      letterSpacing: 0,
    },
  },
});
